module.exports = __webpack_public_path__ + "res/img/rzlc.1a5603e3.png";